import React, {useContext} from "react";
import {Project} from "../../models/project";

import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../ui/card";
import {Button} from "../ui/button";
import {UserContext} from "../../contexts/UserContext";
import {Link, useParams} from "react-router-dom";
import {Separator} from "@radix-ui/react-separator";
import {RichTextView} from "../ui/richtext";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

type ToolbarProps = {
    name: string;
};

type ProjectInfoProps = {
    project?: Project
}

function Toolbar({name}: ToolbarProps) {
    const userContext = useContext(UserContext);
    const {project_id} = useParams<{ project_id: string }>();

    return (
        <div className="flex justify-between items-center">
            <div className="text-2xl mr-2">{name}</div>
            <div className="flex space-x-2">
                <Button variant="outline">
                    {" "}
                    <Link to={`/project/${project_id}/edit`}>More</Link>
                </Button>
                {userContext?.company_type === "developer" ? (
                    <Button variant="outline">
                        <Link to={`/project/${project_id}/edit`}>Edit</Link>
                    </Button>
                ) : null}
            </div>
        </div>
    );
}


export function ProjectInfoDeveloper({project}: ProjectInfoProps) {
    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <Toolbar name={project?.name}/>
                </CardTitle>
            </CardHeader>
            <CardContent className="columns-2">
                <p>
                    <strong>Address: </strong> {String(project?.address.address)}
                </p>
                <p>
                    <strong>Stage:</strong> {project.stage}
                </p>
            </CardContent>
        </Card>
    );
}

export function ProjectInfoBuilder({project}: ProjectInfoProps) {
    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }
    return (
        <Card>
            <CardHeader>
                <Toolbar name={project?.name}/>
                <CardDescription> Project Info </CardDescription>
            </CardHeader>
            <CardContent>
                <div className="columns-2">
                    <div>
                        <p>
                            <strong>Address:</strong> {String(project?.address.address)}
                        </p>
                        <p>
                            <strong>Developer:</strong> {project?.company?.name}
                        </p>
                    </div>
                    <div>
                        <p>
                            <strong>GSF:</strong>{" "} {project.gsf}
                        </p>
                        <p>
                            <strong>Stage:</strong> {project.stage}
                        </p>
                    </div>
                </div>
                <br/>
                <div>
                    <strong>Description:</strong>
                    <div className="text-sm text-ellipsis overflow-y-scroll max-h-36">
                        {" "}
                        <RichTextView initialValue={project.description as string}/>
                    </div>
                </div>
            </CardContent>
            <Separator></Separator>
            <CardFooter>
                <p>Instructions to bidders</p>
                <p></p>
            </CardFooter>
        </Card>
    );
}

